import React from "react";
import Header from "../layout/header";
import { useState,useEffect } from "react";
import { Container, Row, Col } from 'reactstrap';
import globalVariables from "../../global-variables";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Form from 'react-bootstrap/Form';
import { Link , useNavigate , useParams } from "react-router-dom";
import { GetNewsLetterDistinctYearList } from "../../api/newsletter-distinct-year-function";
import { GetNewsLetterList } from "../../api/newsletter-function";
import Metatag from "../../hooks/Metatag";
import NewsLetterYearWiseFilter from "../../common/NewsLetterYearWiseFilter";
import axios from "axios";
import WOW from "wowjs";

export default function Newsletter() {

    let { nletter_year } = useParams();
	const qs_nletter_year = nletter_year;

     // constant to be used on the page
     const [newsletter, setNewsLetterList] = useState(null);

    const [newsletteryear, setNewsLetterYearList] = useState([]);

    const navigate =  useNavigate();

    // success function when the list is retrived
    const OnGetNewsLetterSuccess = (p_response) => {
       // set the list for looping
       setNewsLetterList(p_response);
   }

   useEffect(()=>{

    setTimeout(() => {

        //call the function to get the newsletter
        // make the object for getting the newsletter list
        let _objNewsLetter = new Object();
        _objNewsLetter.nletter_id = null;
        _objNewsLetter.nletter_status = 1;
        _objNewsLetter._selected_year = qs_nletter_year;
        // call the function to get the newsletter list
        GetNewsLetterList(_objNewsLetter, OnGetNewsLetterSuccess,navigate,navigate);

    }, 100);

   },[qs_nletter_year])


   useEffect(()=>{
        setTimeout(() => {
            // set year wise value for the dropdown 
            if (qs_nletter_year != undefined && qs_nletter_year != null && qs_nletter_year != "") {

                document.getElementById("ddlNLetterYear").value = qs_nletter_year;
            }
        }, 100);
    },[newsletter])

    // things to be done when the page is loaded
    useEffect(() => {
         //make the object for getting the report year list
         let _objNLetterYear = new Object();
         _objNLetterYear.nletter_status = 1;

        //Get news type yesr List
        axios.post(globalVariables.variables.strApiUrl + "/nletterApi/getnletterdistinctyear", _objNLetterYear)
        .then((response_list) => {

            if(response_list.data === "error")
            {
                navigate("/error-page")
            }
            else
            {
                // pass the result in the success function of the respective page
                setNewsLetterYearList(response_list.data[0]);
                
            }
            
        });

    }, []);

     useEffect(()=>{
        // initiate the wow effect
        new WOW.WOW({
          live: false,
        }).init();
      },[newsletter])

    return (
        <>
            <Header main_class="bg-header-home"></Header>
            <Metatag title="NDMC Newsletters"
                     keywords="NDMC Newsletters, NDMC Bulletin,  National Disease Modelling Consortium Newsletters"
                     description="National Disease Modelling Consortium Newsletters"/>

            <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('../images/bg-newsletter.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
                    <img src={globalVariables.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
                    <div className="masthead d-flex align-items-center w-100">
                      <Container className="px-4 px-md-5 pb-xl-5 py-4">
                        <div className="d-flex align-items-end">
                          <div className="d-inline-block m-0 d-flex align-items-center">
                            <h1 className="mb-0 fw-bold text-white text-uppercase">Newsletter -</h1>
                            <div className="ms-4 wow fadeInUp">
                                <NewsLetterYearWiseFilter yearList={newsletteryear} _id={"ddlNLetterYear"} navigate_url={"newsletter"}/>
                        
                            </div>
                          </div>
                        </div>
                      </Container>
                    </div>
                  </Container>
            {
                newsletter != null ? 

                newsletter.length > 0 ?
                  
                    <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
                        {/* <div className="border p-md-4 p-2 rounded-3 mb-4"> */}
                            <Row className="row row-cols-lg-4 row-cols-md-2 row-cols-1">
                                {
                                    newsletter.map((val) => {
                                        return(
                                            <>
                                                {
                                                 //image 
                                                    val.nletter_thumbnail != null && val.nletter_thumbnail != "" ?
                                                    <Col className="text-center ">
                                                        <Link to={globalVariables.variables.strApiUrl + "/newsletter-document/" + val.nletter_document} target="_blank" className="text-decoration-none text-center newsl">
                                                            <figure class="position-relative overflow-hidden  d-inline-block border rounded-3 fadeInUp">
                                                            <img src={globalVariables.variables.strApiUrl + "/newsletter-thumbnail/" + val.nletter_thumbnail} className="img-fluid bg-img mb-3 wow fadeIn" alt={val.nletter_title} title={val.nletter_title} />
                                                            </figure>
                                                            <div class="wow fadeInUp">
                                                                <h6 class="mb-0 newsl">
                                                                {val.nletter_title}
                                                                </h6>
                                                            </div>
                                                        </Link>
                                                    </Col>
                                                    :
                                                    <Col className="text-center">
                                                        <Link to={globalVariables.variables.strApiUrl + "/newsletter-document/" + val.nletter_document} target="_blank" className="text-decoration-none text-center newsl">
                                                            <figure class="position-relative overflow-hidden  d-inline-block border rounded-3">
                                                            <img src={globalVariables.variables.strApiUrl + "/newsletter-thumbnail/" + val.nletter_thumbnail} className="img-fluid bg-img mb-3 wow fadeIn" alt={val.nletter_title} title={val.nletter_title} />
                                                            </figure>
                                                            <div class="wow fadeInUp">
                                                                <h6 class="mb-0  newsl">
                                                                {val.nletter_title}
                                                                </h6>
                                                            </div>
                                                        </Link>
                                                    </Col>
                                                }
                                            </>
                                        )
                                       
                                    })
                                }

                            </Row>
                        {/* </div> */}
                    </Container>
                    :
                    
                    <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
                            <Row>
                                <span className="text-center">Newsletters will be posted in due course</span>
                            </Row>
                        </Container>
                :
                <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
                        <Row>
                            <span className="text-center">Loading...</span>
                        </Row>
                </Container>
            }     
            <Breadcrumb className="breadcrumb-panel">
            <Breadcrumb.Item href={globalVariables.variables.strDomainUrl}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>News & Events</Breadcrumb.Item>
                <Breadcrumb.Item active>Newsletter</Breadcrumb.Item>
            </Breadcrumb>
        </>
    );
};